import 'utils-web'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { Themed } from 'hooked'
import { Toaster } from 'dui/toast'
import { Auth } from 'authy-react'

import { authService } from '@/api'
import { store } from '@/store'
import { router } from '@/router'

import './index.scss'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <Themed>
        <Auth authHostUrl={import.meta.env.VITE_API_URL} service={authService}>
          <RouterProvider router={router} />
        </Auth>
        <Toaster />
      </Themed>
    </Provider>
  </StrictMode>,
)
